<template>
    <div>
        <!-- Line Chart-->
        <apexchart
            ref="lineChartRef"
            :type="lineChart.chart.type"
            :height="lineChart.chart.height"
            :series="lineChart.series"
            :options="lineChart"
        />
    </div>
    <div v-if="values.length > 0">
        <button type="button" @click="showHelp = !showHelp">
            <IconHelpCircle
                class="h-6 w-6 text-gray-400 group-hover:text-gray-300 group-focus:text-gray-300 transition ease-in-out duration-150"
            />
        </button>
        <transition
            enter-active-class="transition ease-linear duration-200"
            enter-from-class="opacity-0"
            enter-to-class="opacity-100"
            leave-active-class="transition ease-linear duration-150"
            leave-from-class="opacity-100"
            leave-to-class="opacity-0"
        >
            <AppWell v-if="showHelp" class="text-gray-600">
                <div class="md:grid md:grid-cols-3 md:gap-6">
                    <AppCard class="mt-1">
                        <div class="flex gap-x-2 items-center">
                            <div>
                                <img
                                    src="/img/utils/activity_responses_graph_balanced.svg"
                                    alt=""
                                    class="w-20 inline-block"
                                />
                            </div>
                            <div>{{ $t('messages.activity_responses_graph_balanced') }}</div>
                        </div>
                    </AppCard>
                    <AppCard class="mt-1">
                        <div class="flex gap-x-2 items-center">
                            <div>
                                <img
                                    src="/img/utils/activity_responses_graph_easy.svg"
                                    alt=""
                                    class="w-20 inline-block"
                                />
                            </div>

                            <div>{{ $t('messages.activity_responses_graph_easy') }}</div>
                        </div>
                    </AppCard>
                    <AppCard class="mt-1">
                        <div class="flex gap-x-2 items-center">
                            <div>
                                <img
                                    src="/img/utils/activity_responses_graph_hard.svg"
                                    alt=""
                                    class="w-20 inline-block"
                                />
                            </div>

                            <div>{{ $t('messages.activity_responses_graph_hard') }}</div>
                        </div>
                    </AppCard>
                </div>
            </AppWell>
        </transition>
    </div>
    <div>
        <!-- Bar Chart-->
        <apexchart
            ref="barChartRef"
            :type="barChart.chart.type"
            :height="barChart.chart.height"
            :series="barChart.series"
            :options="barChart"
        />
    </div>
</template>

<script>
import GradeTranslator from '@/classes/GradeTranslator.js';
import { IconHelpCircle } from '@tabler/icons-vue';
import AppWell from '@/Shared/AppWell.vue';
import AppCard from '@/Shared/AppCard.vue';

export default {
    name: 'ActivityGradeResponsesGraphs',
    components: { AppCard, AppWell, IconHelpCircle },
    props: {
        values: {
            type: Array,
            required: false,
            default: () => [],
        },
        barChartOptions: {
            type: Object,
            required: true,
        },
        lineChartOptions: {
            type: Object,
            required: true,
        },
        ranges: {
            type: Array,
            required: true,
        },
    },
    data: function () {
        return {
            barChart: JSON.parse(JSON.stringify(this.barChartOptions)),
            lineChart: JSON.parse(JSON.stringify(this.lineChartOptions)),
            start: false,
            showHelp: false,
        };
    },
    computed: {
        counters: function () {
            const gradeTranslator = new GradeTranslator(this.ranges);
            if (gradeTranslator === undefined) {
                return [];
            }
            if (!this.start) {
                return [];
            }
            const counters = gradeTranslator.getCounterMap();

            Array.from(this.values).forEach((s) => {
                let key = gradeTranslator.scoreToLetter(s);
                if (key) {
                    let index = counters.findIndex((c) => c.key === key);
                    counters[index].value++;
                }
            });

            return counters;
        },
        missedStudentsCount: function () {
            return this.values.filter((s) => s === null).length;
        },
        barChartValues: function () {
            const data = [
                {
                    name: this.$t('messages.activity_absent'),
                    data: [this.missedStudentsCount],
                },
            ];

            this.counters.forEach((counter) => {
                data.push({
                    name: counter.key,
                    data: [counter.value],
                });
            });

            return data;
        },
        lineChartValues: function () {
            const values = [];
            this.counters.forEach((counter) => {
                values.push(counter.value);
            });

            return [
                {
                    name: this.$t('messages.number_of_students'),
                    data: values,
                },
            ];
        },
    },
    mounted() {
        this.start = true;
    },
    watch: {
        lineChartValues: {
            handler: function (newLineChartValues) {
                this.$nextTick(() => {
                    this.lineChart.series = newLineChartValues;
                });
            },
        },
        barChartValues: {
            handler: function (newBarChartValues) {
                this.$nextTick(() => {
                    this.barChart.series = newBarChartValues;
                });
            },
        },
    },
};
</script>
